import { useSelector } from 'react-redux';
import useFeature from 'services/features/useFeature';
import { getPartnerNotesData, PartnerNotesData } from 'store/partnerNotes';

export default function useGetPartnerNotes(): PartnerNotesData {
  const { isFeatureEnabled } = useFeature('partner_recommendation_note');

  const partnerNotesData = useSelector(getPartnerNotesData());

  if (!isFeatureEnabled) return {};

  return partnerNotesData;
}
